var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicketIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9002 15.1404V14.9466M14.8997 12.1375V11.9437M14.8997 9.14741V8.95358M5.51196 3.45996H12.5012C12.5409 4.87503 13.7005 6.00996 15.1252 6.00996C16.5499 6.00996 17.7094 4.87503 17.7491 3.45996H19.4884C21.5936 3.45996 23.3002 5.16655 23.3002 7.27173V16.7287C23.3002 18.8338 21.5936 20.5404 19.4884 20.5404H17.7491C17.7094 19.1254 16.5499 17.9904 15.1252 17.9904C13.7005 17.9904 12.5409 19.1254 12.5012 20.5404H5.51197C3.40679 20.5404 1.70021 18.8338 1.70021 16.7287L1.7002 7.27173C1.7002 5.16655 3.40678 3.45996 5.51196 3.45996Z",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketIcon);
export default __webpack_public_path__ + "static/media/ticket-icon.8089cfaf8726c168f7894a1d98703869.svg";
export { ForwardRef as ReactComponent };